'use client';

import { useAppContext } from '@/context/app';
import { setCartPageColumn } from '@/util/cart-page-column-storage';

export const useResolvePageColumn = () => {
  const [
    ,
    {
      actions: { setCartActiveColumn },
    },
  ] = useAppContext();

  const resolvePageColumn = productCategories => {
    if (!Array.isArray(productCategories) || productCategories.length === 0) {
      setCartActiveColumn('home');
      return;
    }

    const lastCartItemIsAttireCategory = productCategories.some(x => x?.uid === 'NTQ=');

    setCartActiveColumn(lastCartItemIsAttireCategory ? 'attire' : 'home');
    setCartPageColumn(lastCartItemIsAttireCategory ? 'attire' : 'home');
  };

  return { resolvePageColumn };
};
